import { Button, ButtonStyles, Icons, SelectList } from '@silverfort/sf-components';
import { FC, useCallback, useMemo } from 'react';
import { useActiveDirectoryAccessContext } from '../../../../context';
import { useHistory } from 'react-router-dom';
import { useApplicationsContext } from '../context/ApplicationsContext';

export const ApplicationsOptionsMenu: FC = () => {
    const history = useHistory();

    const { hasAccessIntelligenceEditorRole } = useActiveDirectoryAccessContext();
    const { setShowUploadApplicationsModal } = useApplicationsContext();

    const openUploadApplicationsModal = useCallback(() => {
        setShowUploadApplicationsModal(true);
    }, [setShowUploadApplicationsModal]);

    const navigateToCreateApplicationPage = useCallback(() => {
        history.push('/accessAnalysis/Create');
    }, [history]);

    const menuItems = useMemo(
        () => [
            {
                disabled: !hasAccessIntelligenceEditorRole,
                onClick: navigateToCreateApplicationPage,
                title: 'Create new application'
            },
            {
                disabled: !hasAccessIntelligenceEditorRole,
                onClick: openUploadApplicationsModal,
                title: 'Upload from CSV'
            }
        ],
        [hasAccessIntelligenceEditorRole, navigateToCreateApplicationPage, openUploadApplicationsModal]
    );

    return (
        <div className={`flex h-full flex-shrink-0 items-center justify-center`}>
            <SelectList
                items={menuItems}
                menuProps={{
                    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                    transformOrigin: { vertical: 'top', horizontal: 'right' }
                }}
                triggerProps={{
                    buttonStyle: ButtonStyles.Primary,
                    iconLeft: Icons.MoreVertical,
                    iconSize: 16
                }}
                TriggerComponent={Button}
            />
        </div>
    );
};
